var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _line, _circle, _circle2, _path, _rect21, _ellipse, _circle3, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsEmptyStateImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 270,
    viewBox: "0 0 276 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 11,
    width: 171,
    height: 221,
    fill: "#E9FAFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 79,
    width: 117,
    height: 13,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 98,
    width: 117,
    height: 13,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 117,
    width: 117,
    height: 13,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 142,
    width: 47,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 46,
    width: 47,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 154,
    width: 76,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 166,
    width: 63,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 210,
    width: 46,
    height: 8,
    rx: 4,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 98,
    width: 112,
    height: 171,
    rx: 15,
    fill: "white",
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 178,
    width: 23,
    height: 17,
    rx: 6,
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 208,
    width: 23,
    height: 17,
    rx: 6,
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 238,
    width: 23,
    height: 17,
    rx: 6,
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 178,
    width: 22,
    height: 17,
    rx: 6,
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 208,
    width: 22,
    height: 17,
    rx: 6,
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 238,
    width: 22,
    height: 17,
    rx: 6,
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 178,
    width: 23,
    height: 17,
    rx: 6,
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 208,
    width: 23,
    height: 17,
    rx: 6,
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 208,
    width: 23,
    height: 47,
    rx: 6,
    fill: "#24557C",
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 127,
    width: 84,
    height: 38,
    rx: 6,
    fill: "#24557C",
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 189,
    y1: 113,
    x2: 237,
    y2: 113,
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134.664,
    cy: 198.664,
    r: 43,
    fill: "#FDE19C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.664,
    cy: 198.664,
    r: 34,
    transform: "rotate(30 134.664 198.664)",
    fill: "#FDD269"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.664 228.109C133.926 237.497 154.72 231.926 164.108 215.664C173.497 199.402 167.926 178.608 151.664 169.219",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 130.062,
    y: 178.664,
    width: 10,
    height: 38,
    rx: 5,
    fill: "#23547B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 131.318,
    cy: 180.97,
    rx: 13.4837,
    ry: 8.51601,
    transform: "rotate(-42.8462 131.318 180.97)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 122.062,
    cy: 199.664,
    r: 4,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6539 175.637C12.6421 188.229 23.8942 195.211 28.7947 196.924C43.408 196.925 53.072 184.257 59.2006 176.646C70.7035 162.349 104.212 87.4363 115.715 73.1388C130.506 54.6414 146.717 35.1705 168.952 27.4805C197.735 17.5376 231.38 33.1669 240.448 60.7933C243.749 70.7114 243.23 83.0166 239.672 94.9225",
    stroke: "#00A8D7",
    strokeWidth: 2.01828,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.08 6.08"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.311 91.506C225.975 68.9422 209.618 58.7688 193.937 58.9956",
    stroke: "#00A8D7",
    strokeWidth: 2.01828,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.08 6.08"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M274.4 79.1H273.7C271.9 79.1 270.5 77.7 270.5 75.9V74.2C270.5 73.5 270 73 269.3 73C268.6 73 268.1 73.5 268.1 74.2V75.9C268.1 77.7 266.7 79.1 264.9 79.1H264.2C263.5 79.1 263 79.6 263 80.3C263 81 263.5 81.5 264.2 81.5H264.9C266.7 81.5 268.1 82.9 268.1 84.7V86.9C268.1 87.6 268.6 88.1 269.3 88.1C270 88.1 270.5 87.6 270.5 86.9V84.7C270.5 82.9 271.9 81.5 273.7 81.5H274.4C275.1 81.5 275.6 81 275.6 80.3C275.6 79.6 275.1 79.1 274.4 79.1Z",
    fill: "#7FD8EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.4 246.1H103.7C101.9 246.1 100.5 244.7 100.5 242.9V241.2C100.5 240.5 100 240 99.3 240C98.6 240 98.1 240.5 98.1 241.2V242.9C98.1 244.7 96.7 246.1 94.9 246.1H94.2C93.5 246.1 93 246.6 93 247.3C93 248 93.5 248.5 94.2 248.5H94.9C96.7 248.5 98.1 249.9 98.1 251.7V253.9C98.1 254.6 98.6 255.1 99.3 255.1C100 255.1 100.5 254.6 100.5 253.9V251.7C100.5 249.9 101.9 248.5 103.7 248.5H104.4C105.1 248.5 105.6 248 105.6 247.3C105.6 246.6 105.1 246.1 104.4 246.1Z",
    fill: "#7FD8EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M258.8 64.1H258.3C257.1 64.1 256.1 63.1 256.1 61.9V60.8C256.1 60.4 255.7 60 255.3 60C254.9 60 254.5 60.4 254.5 60.8V62C254.5 63.2 253.5 64.2 252.3 64.2H251.8C251.4 64.2 251 64.6 251 65C251 65.4 251.4 65.8 251.8 65.8H252.3C253.5 65.8 254.5 66.8 254.5 68V69.5C254.5 69.9 254.9 70.3 255.3 70.3C255.7 70.3 256.1 69.9 256.1 69.5V68C256.1 66.8 257.1 65.8 258.3 65.8H258.8C259.2 65.8 259.6 65.4 259.6 65C259.7 64.4 259.3 64.1 258.8 64.1Z",
    fill: "#7FD8EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsEmptyStateImage);
export default __webpack_public_path__ + "static/media/documents-empty-state-image.6cf32a45acacc7a15461b7e53c279165.svg";
export { ForwardRef as ReactComponent };